import React, { useEffect, useState } from "react";
import { Admin, DataProvider, Resource, usePermissions } from "react-admin";
import buildGraphQLProvider from "./data-provider/graphqlDataProvider";
import { theme } from "./theme/theme";
import Login from "./Login";
import "./App.scss";
import Dashboard from "./pages/Dashboard.jsx";
import { UserList } from "./user/UserList";
import { UserCreate } from "./user/UserCreate";
import { UserEdit } from "./user/UserEdit";
import { UserShow } from "./user/UserShow";
import { DoctorList } from "./doctor/DoctorList";
import { DoctorCreate } from "./doctor/DoctorCreate";
import { DoctorEdit } from "./doctor/DoctorEdit";
import { DoctorShow } from "./doctor/DoctorShow";
import { PatientList } from "./patient/PatientList";
import { PatientCreate } from "./patient/PatientCreate";
import { PatientEdit } from "./patient/PatientEdit";
import { PatientShow } from "./patient/PatientShow";
import { DoctorSaleList } from "./doctorSale/DoctorSaleList";
import { DoctorSaleCreate } from "./doctorSale/DoctorSaleCreate";
import { DoctorSaleEdit } from "./doctorSale/DoctorSaleEdit";
import { DoctorSaleShow } from "./doctorSale/DoctorSaleShow";
import { jwtAuthProvider } from "./auth-provider/ra-auth-jwt";
import labelsTranslation from "./translations/tranlation";
import { PatientList as OperatorAllPatientList } from "./operatorPatient/AllPatientList";
import { PatientList as OperatorNewPatientList } from "./operatorPatient/NewPatientList";
import { PatientShow as OperatorPatientShow } from "./operatorPatient/PatientShow";
import { PatientCreate as OperatorPatientCreate } from "./operatorPatient/PatientCreate";
import { PatientEdit as OperatorPatientEdit } from "./operatorPatient/PatientEdit.jsx";
import { SettlementList } from "./settlement/SettlementList";
import { SettlementShow } from "./settlement/SettlementShow";
import { SettlementCreate } from "./settlement/SettlementCreate";
import { SettlementEdit } from "./settlement/SettlementEdit";
import { TellerSettlementList } from './settlement/TellerSettlementList'
import { PatientList as AccountantPatientList } from "./AccountantPatients/PatientList";
import { DoctorSaleList as AccountantDoctorSaleList } from "./AccountantPatients/DoctorSaleList";
import farsiMessages from "ra-language-farsi";
import polyglotI18nProvider from "ra-i18n-polyglot";
import RTL from "./RTL";

const i18nProvider = polyglotI18nProvider(() => farsiMessages, "fa", {
  allowMissing: true,
});

// const customPermissions = ["doctor_sale.operator"];

const App = (): React.ReactElement => {
  const [dataProvider, setDataProvider] = useState<DataProvider | null>(null);
  const [permissions, setPermissions] = useState<string[]>([]);
  async function fetchPermission() {
    try {
      const permissions = await jwtAuthProvider.getPermissions(true);
      setPermissions(permissions);
    } catch (error) {
      // console.error(error);
    }
  }
  useEffect(() => {
    fetchPermission();
  }, []);
  useEffect(() => {
    // console.log(buildGraphQLProvider);
    buildGraphQLProvider
      .then((provider: any) => {
        setDataProvider(() => provider);
      })
      .catch((error: any) => {
        // console.log(error);
      });
  }, []);
  if (!dataProvider) {
    return <div>Loading</div>;
  }

  const renderWithPermission = (permissionsList: string[]) => {
    if (
      permissionsList.includes("doctor_sale.doctor") ||
      permissionsList.includes("sport_coach.coach")
    ) {
      return [
        <Resource
          name="Patient"
          options={{
            label: labelsTranslation.userList.title,
          }}
          list={PatientList}
          create={PatientCreate}
          edit={PatientEdit}
          show={PatientShow}
        />,
        <Resource name="Doctor" />,
        <Resource
          name="Settlement"
          options={{
            label: "گزارش واریز",
          }}
          list={SettlementList}
        />,

        <Resource
          name="DoctorSale"
          options={{
            label: "گزارش فروش",
          }}
        />,
        <Resource name="User" />,
      ];
    } else if (
      permissionsList.includes("doctor_sale.operator") ||
      permissionsList.includes("sport_coach.operator")
    ) {
      return [
        <Resource
          name="Patient"
          options={{
            label: "لیست کاربران جدید",
          }}
          list={OperatorNewPatientList}
          edit={OperatorPatientEdit}
          show={OperatorPatientShow}
        />,
        <Resource
          name=""
          options={{
            label: "لیست کل کاربران",
          }}
          list={OperatorAllPatientList}
          edit={OperatorPatientEdit}
          show={OperatorPatientShow}
          // create={OperatorPatientCreate}
        />,
        <Resource name="Doctor" />,
        <Resource name="DoctorSale" />,
        <Resource name="User" />,
      ];
    } else if (permissionsList.includes("doctor_sale.accountant")) {
      return [
        <Resource
          name="Patient"
          options={{
            label: "لیست کل کاربران",
          }}
          list={AccountantPatientList}
        />,
        <Resource
          name="DoctorSale"
          options={{
            label: "لیست کاربران دارای فروش",
          }}
          list={AccountantDoctorSaleList}
        />,
        <Resource name="Doctor" />,
        <Resource name="User" />,
      ];
    } else if (
      permissionsList.includes("doctor_sale.teller") ||
      permissionsList.includes("doctor_sale.admin")
    ) {
      return [
        <Resource
          name="Settlement"
          options={{
            label: "گزارش واریز",
          }}
          list={TellerSettlementList}
          show={SettlementShow}
          edit={SettlementEdit}
          create={SettlementCreate}
        />,
        <Resource name="Patient" />,
        <Resource name="DoctorSale" />,
        <Resource name="Doctor" />,
        <Resource name="User" />,
      ];
    }
    return <></>;
  };

  return (
    <div className="App">
      <RTL>
        <Admin
          title={"Doctors"}
          dataProvider={dataProvider}
          authProvider={jwtAuthProvider}
          theme={theme}
          dashboard={
            permissions.includes("doctor_sale.doctor") ||
            permissions.includes("sport_coach.coach")
              ? Dashboard
              : undefined
          }
          loginPage={Login}
          i18nProvider={i18nProvider}
        >
          {(permissions) => renderWithPermission(permissions)}
        </Admin>
      </RTL>
    </div>
  );
};

export default App;
